export enum RouteName {
  List = 'card-schemes',
  Id = 'card-schemes-id',
}
